import { listenForDependentFields, recalculateAmounts } from '@engine/features/virtual_terminal/vt_transaction_items_dependent_fields';
import { options } from '@engine/features/apply_chosen';
var counter = 1;

function hideItemsContainer() {
  $('#items-container').hide();
  $('#items-container').next().hide();
  $('#items-container').find(':input').not('.chosen-search-input').attr('disabled', 'disabled');
}

function isInvoiceRefund() {
  return Boolean($('form#new_invoice_refund_transaction'));
}

function listenForDeleteItem() {
  if ($('#items-container').length === 0) {
    return false;
  }

  $(document).on('click', 'btn.btn-danger', function () {
    if ($('#items-container').children().length === 1 && isInvoiceRefund()) {
      hideItemsContainer();
      $('.add-refund-item').removeClass('hidden');
    } else {
      $(this).parents('.panel-default').remove();
    }

    recalculateAmounts();
  });
}

function replaceItemInputAttributes(item) {
  var inputs = item.find(':input').not('.chosen-search-input');
  inputs.val('');
  inputs.attr('name', function (index, currentValue) {
    return currentValue.replace('[item0]', '[item' + counter + ']');
  });
  inputs.attr('id', function (index, currentValue) {
    return currentValue.replace('items_item0', 'items_item' + counter);
  });
}

function handleItemCollapse(item) {
  var collapseItemAttr = 'collapse_item' + counter;
  item.find('btn.btn-danger').removeClass('remove-item0 hidden').addClass('remove-item' + counter);
  item.find('.panel-collapse').attr('id', collapseItemAttr);
  item.find('.panel-heading').attr('data-target', '#' + collapseItemAttr);
  $(document).find('[id^="collapse_item"]').collapse('hide');
  item.find('.panel-collapse').collapse('show');
}

function handleChosenInputs(item) {
  item.find('div#items_item0_item_type_chosen').remove();
  item.find('select').chosen(options);
}

function listenForNewItem() {
  $('.add-item').on('click', function () {
    var newItem = $('#transaction-item0').clone();
    newItem.attr('id', 'transaction-item' + counter);
    replaceItemInputAttributes(newItem);
    handleItemCollapse(newItem);
    handleChosenInputs(newItem);
    $('#items-container').append(newItem);
    counter += 1;
  });
}

function emptyForm() {
  var isNotBlank = $('#transaction-item0').find('input').filter(function () {
    return this.value;
  }).length;
  return !isNotBlank;
}

function listenForInvoiceRefund() {
  if ($('#new_invoice_refund_transaction').length === 0) {
    return false;
  }

  if (emptyForm()) {
    hideItemsContainer();
  } else {
    $('.add-refund-item').addClass('hidden');
    $('#items-container').find('btn.btn-danger').removeClass('hidden');
  }

  $('.add-refund-item').on('click', function () {
    $('.add-refund-item').addClass('hidden');
    $('#items-container').show();
    $('#items-container').next().show();
    $('btn.remove-item0').removeClass('hidden');
    $('#items-container').find(':input').not('.chosen-search-input').prop('disabled', false);
    $('.for_chosen').trigger('chosen:updated');
  });
}

var Invoice = {
  listenForNewItem: listenForNewItem,
  listenForDeleteItem: listenForDeleteItem,
  listenForInvoiceRefund: listenForInvoiceRefund,
  listenForDependentFields: listenForDependentFields
};
export default Invoice;